import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { API_CONSTANTS } from '../base/api-constants';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  private readonly candidatePaywallEnabledSubject = new BehaviorSubject<boolean>(true);
  private readonly profileRefreshEnabledSubject = new BehaviorSubject<boolean>(true);
  private readonly profileRefreshIntervalMonthsSubject = new BehaviorSubject<number>(4);
  private loaded = false;

  readonly candidatePaywallEnabled$ = this.candidatePaywallEnabledSubject.asObservable();
  readonly profileRefreshEnabled$ = this.profileRefreshEnabledSubject.asObservable();

  constructor(private readonly http: HttpClient) {}

  /** Call once at app bootstrap (APP_INITIALIZER). */
  load(): Observable<boolean> {
    if (this.loaded) {
      return of(this.candidatePaywallEnabledSubject.value);
    }

    const url = `${environment.apiBaseUrl}${API_CONSTANTS.AppConfig.GetPublic}`;
    return this.http.get<any>(url).pipe(
      map((res) => {
        const data = res?.data ?? {};
        this.profileRefreshEnabledSubject.next(data.profileRefreshEnabled !== false);
        this.profileRefreshIntervalMonthsSubject.next(
          Number(data.profileRefreshIntervalMonths) || 4
        );
        return !!data.candidatePaywallEnabled;
      }),
      tap((enabled) => {
        this.loaded = true;
        this.candidatePaywallEnabledSubject.next(enabled);
      }),
      catchError(() => {
        this.loaded = true;
        this.candidatePaywallEnabledSubject.next(true);
        this.profileRefreshEnabledSubject.next(true);
        this.profileRefreshIntervalMonthsSubject.next(4);
        return of(true);
      })
    );
  }

  isCandidatePaywallEnabled(): boolean {
    return this.candidatePaywallEnabledSubject.value;
  }

  isProfileRefreshEnabled(): boolean {
    return this.profileRefreshEnabledSubject.value;
  }

  getProfileRefreshIntervalMonths(): number {
    return this.profileRefreshIntervalMonthsSubject.value;
  }
}
